import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBalancete = '/service/balanceteDespesaRestService/'

class DespesasPorOrgaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracoes.length > 0 ? filtro.administracoes.map(e => e.value).join() : this.state.adms,
            exercicio: filtro.exercicio.value,
            mes: filtro.mes && filtro.mes.value < 10 ? '0' + filtro.mes.value : filtro.mes.value,
            recursoContabil: filtro.recursosVinculados ? filtro.recursosVinculados.map(e => e.value).join() : '',
            codigoDestinacao: filtro.recursosDestinacao ? filtro.recursosDestinacao.map(e => e.value).join() : '',
            orgaoContabil: filtro.orgaos ? filtro.orgaos.map(e => e.value).join() : '',
            funcao: filtro.funcoes ? filtro.funcoes.map(e => e.value).join() : '',
            subFuncao: filtro.subFuncoes ? filtro.subFuncoes.map(e => e.value).join() : '',
            despesa: filtro.despesas ? filtro.despesas.map(e => e.value).join() : '',
            unidadeContabil: '',
        }
        return this.conex.post(urlBalancete + 'recuperarDepesaPorOrgao/', JSON.stringify(data))
    }
}

export default DespesasPorOrgaoService
